import GMSFillButton from "../../Common/components/GMSFillButton";
import React from "react";
import PropTypes from "prop-types";

function NoData(props) {
  return (
    <React.Fragment>
      <div className="tw-flex tw-justify-center tw-items-center">
        <figure className=" tw-text-center">
          <img
            src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"}
            alt="logo"
            className="tw-max-w-full tw-max-h-full tw-mt-20"
          />
          <div className="tw-mr-[30%]">
            <label
              className={`tw-text-[24px] tw-text-[#091caa] tw-font-semibold`}
            >
              {`No data in ${props?.module?.toLowerCase()}`}
            </label>
            <p>
              You can click on import data to configure and import{" "}
              {props?.module?.toLowerCase()} data
            </p>
            <br />
            <GMSFillButton
              name="Data Import"
              disabled={!props?.canImportData}
              onClick={() => props?.setShowImportDataForm(true)}
            />
          </div>
        </figure>
      </div>
    </React.Fragment>
  );
}

NoData.propTypes = {
  module: PropTypes.string, 
  canImportData: PropTypes.bool, 
  setShowImportDataForm: PropTypes.func 
};

export default NoData;
